// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"ProductSpotlight_iconContainer__DP9PI"};